var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_CART_RECOMMENDATIONS = exports.GET_PRODUCT_RECOMMENDATIONS = exports.GET_POPULAR_PRODUCTS = exports.GET_PRODUCT_IMAGES_BY_HANDLE = exports.GET_PRODUCT_SIBLINGS_BY_HANDLE = exports.GET_PRODUCTS_BY_HANDLE_LIGHT = exports.GET_PRODUCTS_BY_HANDLE = exports.GET_PRODUCT_COMPLETE = exports.GET_PRODUCT_STANDARD = exports.GET_PRODUCT_LITE = exports.GET_PRODUCT_AVAILABILITY = exports.GET_PRODUCT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const productFragment_1 = require("../fragments/productFragment");
const variantFragment_1 = require("../fragments/variantFragment");
const imageFragment_1 = require("../fragments/imageFragment");
exports.GET_PRODUCT = (0, graphql_tag_1.default)`
  query (
    $countryCode: CountryCode!
    $handle: String!
    $parentQuery: String
    $firstCollections: Int
    $firstImages: Int
    $firstMedia: Int
    $metafieldIdentifiers: [HasMetafieldsIdentifier!]!
    $firstVariants: Int
    $afterVariants: String
  ) @inContext(country: $countryCode) {
    product: productByHandle(handle: $handle) {
      ...ProductFragment
    }
    grouped: products(query: $parentQuery, first: $firstVariants) {
      edges {
        node {
          ...ProductFragment
        }
      }
    }
  }
  ${productFragment_1.PRODUCT_FRAGMENT}
`;
exports.GET_PRODUCT_AVAILABILITY = (0, graphql_tag_1.default)`
  query ($countryCode: CountryCode!, $handle: String!) @inContext(country: $countryCode) {
    product: productByHandle(handle: $handle) {
      tags
      variants(first: 100) {
        edges {
          node {
            ...VariantFragmentAvailability
          }
        }
      }
    }
  }
  ${variantFragment_1.VARIANT_FRAGMENT_AVAILABILITY}
`;
exports.GET_PRODUCT_LITE = (0, graphql_tag_1.default)`
  query ($countryCode: CountryCode!, $handle: String!, $firstImages: Int, $firstVariants: Int) @inContext(country: $countryCode) {
    product: productByHandle(handle: $handle) {
      id
      handle
      description
      title
      tags
      images(first: $firstImages) {
        edges {
          node {
            ...ImageFragment
          }
        }
      }
      variants(first: $firstVariants) {
        edges {
          node {
            ...VariantFragment
          }
        }
      }
    }
  }
  ${imageFragment_1.IMAGE_FRAGMENT}
  ${variantFragment_1.VARIANT_FRAGMENT}
`;
exports.GET_PRODUCT_STANDARD = (0, graphql_tag_1.default)`
  query (
    $countryCode: CountryCode!
    $id: ID!
    $handle: String!
    $parentQuery: String
    $firstCollections: Int
    $firstImages: Int
    $firstMedia: Int
    $metafieldIdentifiers: [HasMetafieldsIdentifier!]!
    $firstVariants: Int
    $afterVariants: String
  ) @inContext(country: $countryCode) {
    product: productByHandle(handle: $handle) {
      ...ProductFragment
    }
    grouped: products(query: $parentQuery, first: $firstVariants) {
      edges {
        node {
          handle
          tags
        }
      }
    }
    recommendations: productRecommendations(productId: $id) {
      handle
      tags
    }
  }
  ${productFragment_1.PRODUCT_FRAGMENT}
`;
exports.GET_PRODUCT_COMPLETE = (0, graphql_tag_1.default)`
  query (
    $countryCode: CountryCode!
    $id: ID!
    $handle: String!
    $parentQuery: String
    $firstCollections: Int
    $firstImages: Int
    $firstMedia: Int
    $metafieldIdentifiers: [HasMetafieldsIdentifier!]!
    $firstVariants: Int
    $afterVariants: String
  ) @inContext(country: $countryCode) {
    product: productByHandle(handle: $handle) {
      ...ProductFragment
    }
    grouped: products(query: $parentQuery, first: $firstVariants) {
      edges {
        node {
          ...ProductFragment
        }
      }
    }
    recommendations: productRecommendations(productId: $id) {
      ...ProductFragment
    }
  }
  ${productFragment_1.PRODUCT_FRAGMENT}
`;
const GET_PRODUCTS_BY_HANDLE = handles => (0, graphql_tag_1.default)`
  query(
    $countryCode: CountryCode!
    $firstCollections: Int
    $firstImages: Int
    $firstMedia: Int
    $metafieldIdentifiers: [HasMetafieldsIdentifier!]!
    $firstVariants: Int
    $afterVariants: String
  ) @inContext(country: $countryCode) {
    ${handles === null || handles === void 0 ? void 0 : handles.map(handle => `
      product${handle.replace(/-/g, "")}: productByHandle(handle: "${handle}") {
        ...ProductFragment
      }
    `)}
  }
  ${productFragment_1.PRODUCT_FRAGMENT}
`;
exports.GET_PRODUCTS_BY_HANDLE = GET_PRODUCTS_BY_HANDLE;
const GET_PRODUCTS_BY_HANDLE_LIGHT = handles => (0, graphql_tag_1.default)`
  query(
    $countryCode: CountryCode!
    $firstImages: Int
    $firstVariants: Int
  ) @inContext(country: $countryCode) {
    ${handles === null || handles === void 0 ? void 0 : handles.map(handle => `
      product${handle.replace(/-/g, "")}: productByHandle(handle: "${handle}") {
        id
        handle
        title
        tags
        images(first: $firstImages) {
          edges {
            node {
              ...ImageFragment
            }
          }
        }
        variants(first: $firstVariants) {
          edges {
            node {
              ...VariantFragment
            }
          }
        }
      }
    `)}
  }
  ${imageFragment_1.IMAGE_FRAGMENT}
  ${variantFragment_1.VARIANT_FRAGMENT}
`;
exports.GET_PRODUCTS_BY_HANDLE_LIGHT = GET_PRODUCTS_BY_HANDLE_LIGHT;
const GET_PRODUCT_SIBLINGS_BY_HANDLE = handles => (0, graphql_tag_1.default)`
  query(
    $countryCode: CountryCode!
  ) @inContext(country: $countryCode) {
    ${handles === null || handles === void 0 ? void 0 : handles.map(handle => `
        product${handle.replace(/-/g, "")}: productByHandle(handle: "${handle}") {
          id
          handle
          title
          tags
          availableForSale
        }
      `)}
  }
`;
exports.GET_PRODUCT_SIBLINGS_BY_HANDLE = GET_PRODUCT_SIBLINGS_BY_HANDLE;
exports.GET_PRODUCT_IMAGES_BY_HANDLE = (0, graphql_tag_1.default)`
  query ($countryCode: CountryCode!, $handle: String!, $firstImages: Int) @inContext(country: $countryCode) {
    product: productByHandle(handle: $handle) {
      images(first: $firstImages) {
        edges {
          node {
            ...ImageFragment
          }
        }
      }
    }
  }
  ${imageFragment_1.IMAGE_FRAGMENT}
`;
exports.GET_POPULAR_PRODUCTS = (0, graphql_tag_1.default)`
  query (
    $countryCode: CountryCode!
    $first: Int!
    $firstImages: Int!
    $firstMedia: Int!
    $metafieldIdentifiers: [HasMetafieldsIdentifier!]!
    $firstCollections: Int!
    $firstVariants: Int!
    $afterVariants: String
  ) @inContext(country: $countryCode) {
    products(first: $first, sortKey: BEST_SELLING) {
      edges {
        node {
          ...ProductFragment
        }
      }
    }
  }
  ${productFragment_1.PRODUCT_FRAGMENT}
`;
exports.GET_PRODUCT_RECOMMENDATIONS = (0, graphql_tag_1.default)`
  query (
    $countryCode: CountryCode!
    $id: ID!
    $firstCollections: Int
    $firstImages: Int
    $firstMedia: Int!
    $metafieldIdentifiers: [HasMetafieldsIdentifier!]!
    $firstVariants: Int
    $afterVariants: String
  ) @inContext(country: $countryCode) {
    recommendations: productRecommendations(productId: $id) {
      ...ProductFragment
    }
  }
  ${productFragment_1.PRODUCT_FRAGMENT}
`;
const GET_CART_RECOMMENDATIONS = ids => (0, graphql_tag_1.default)`
  query(
    $countryCode: CountryCode!
    $firstImages: Int
    $firstVariants: Int
  ) @inContext(country: $countryCode) {
    ${ids === null || ids === void 0 ? void 0 : ids.map((id, index) => `
      product${index}: productRecommendations(productId: "${id}") {
        id
        handle
        title
        tags
        images(first: $firstImages) {
          edges {
            node {
              ...ImageFragment
            }
          }
        }
        variants(first: $firstVariants) {
          edges {
            node {
              ...VariantFragment
            }
          }
        }
      }
    `)}
  }
  ${imageFragment_1.IMAGE_FRAGMENT}
  ${variantFragment_1.VARIANT_FRAGMENT}
`;
exports.GET_CART_RECOMMENDATIONS = GET_CART_RECOMMENDATIONS;